/* ============================================================
   Philip Warren & Son — shared redesign behaviour
   Header/footer are server-rendered (snippets), so this only wires
   the mobile menu and the scroll-reveal observer.
   Ported/trimmed from Claude Design site.js.
   ============================================================ */
(function(){
  function init(){
    // ---------- MOBILE MENU ----------
    var hb = document.getElementById('hamburger');
    var mm = document.getElementById('mobileMenu');
    if (hb && mm){
      var open  = function(){ mm.classList.add('open'); };
      var close = function(){ mm.classList.remove('open'); };
      hb.addEventListener('click', open);
      var scrim = mm.querySelector('.scrim');
      var mclose = mm.querySelector('.m-close');
      if (scrim) scrim.addEventListener('click', close);
      if (mclose) mclose.addEventListener('click', close);
      mm.querySelectorAll('.m-group > button').forEach(function(b){
        b.addEventListener('click', function(){ b.parentElement.classList.toggle('open'); });
      });
      mm.querySelectorAll('.m-sub a, .m-cta, .m-link').forEach(function(a){ a.addEventListener('click', close); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    }

    // ---------- REVEAL ----------
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold:0.12, rootMargin:'0px 0px -50px 0px' });
    els.forEach(function(el){ io.observe(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
